export class DateExtension {
  static IsLeapYearEx(date) {
    return this.IsLeapYear(date.getFullYear());
  }

  static IsLeapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
  }
}
